import { render, staticRenderFns } from "./DesignPane.vue?vue&type=template&id=1a7652c6"
import script from "./DesignPane.vue?vue&type=script&lang=ts"
export * from "./DesignPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports